import { render } from "./lyFormTable.vue?vue&type=template&id=88343c82&scoped=true"
import script from "./lyFormTable.vue?vue&type=script&lang=js"
export * from "./lyFormTable.vue?vue&type=script&lang=js"

import "./lyFormTable.vue?vue&type=style&index=0&id=88343c82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88343c82"]])

export default __exports__